import React from "react";
import pic from "../pic.png";
export default function Hero() {
  return (
    <section className="h-screen flex flex-col justify-center items-center text-center bg-gradient-to-r from-blue-600 to-green-500 text-white px-6">
      <img
        src={pic}
        alt="Daniel Mirigi"
        className="w-70 h-70 rounded-full border-4 border-white shadow-lg mb-6"
      />
      <h2 className="text-4xl md:text-5xl font-bold mb-2">Daniel Mirigi</h2>
      <p className="text-xl">Game Creator | Full-Stack & Blockchain Dev</p>
      <p className="mt-4 max-w-2xl">
        Passionate about crafting digital experiences that make a difference.
        Let's build something amazing together!
      </p>
      <a
        href="#contact"
        className="mt-6 px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg shadow hover:bg-gray-200"
      >
        Contact Me
      </a>
    </section>
  );
}
